import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { ModalServiceInterface } from '../../interfaces/modal-service.interface';
import { ModalData } from '../../models';

@Injectable()
export class ModalService implements ModalServiceInterface {

  _openModalEvent = new Subject<any>();
  _closeModalEvent = new Subject<any>();
  openModalEvent$ = this._openModalEvent.asObservable();
  closeModalEvent$ = this._closeModalEvent.asObservable();

  public openModal<ModalErrorsType = any>(modalData: ModalData<ModalErrorsType>) {
    this._openModalEvent.next(modalData);
  }

  public closeModal(closeAll?: boolean) {
    this._closeModalEvent.next(closeAll);
  }
}
